// extracted by mini-css-extract-plugin
module.exports = {"Select":"ByYear_Select__2ULnm","Dropdown":"ByYear_Dropdown__3L4hf"};